import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { TranslocoModule } from '@jsverse/transloco';
import { GoogleAnalyticsService } from 'src/app/shared/service/google-analytics.service';
import { ClientService } from '../../../../core/services/client.service';
import { Client } from '../../../../domain/models';
import { ProgramCardCollectionComponent } from '../../components';

@Component({
    selector: 'app-program',
    templateUrl: './program.component.html',
    styleUrls: ['./program.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        TranslocoModule,
        ProgramCardCollectionComponent,
        FlexLayoutModule,
        MatButtonModule
    ]
})
export class ProgramComponent implements OnInit {
    client: Client | undefined;

    constructor(
        private readonly _client: ClientService,
        private _googleAnalyticsService: GoogleAnalyticsService
    ) {
        document
            .getElementsByTagName('body')[0]
            .classList.add('blue-background-active');
    }

    ngOnInit(): void {
        this._googleAnalyticsService.pageView('Programs');
        this._client.latest.subscribe((client) => {
            this.client = client;
        });
    }
}
